export default __webpack_public_path__ + "static/media/8.33a5d164.jpg";